import React, { useState } from 'react';
import { Button, Form, FormGroup } from 'reactstrap';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import FormItem from '../../../../common/forms/FormItem';
import TextInput from '../../../../common/forms/input/TextInput';
import FormFooter from '../../../../common/forms/FormFooter';
import PaymentMethodSelect from '../../../../common/forms/select/PaymentMethodSelect';
import {
  isRequired,
  validateLength,
  validateNumber,
  validateRuc,
} from '../../../../../utils/validators';
import { TRANSACTION_TYPE_CREDIT_CARD } from '../../../../../config/constants';

const validateLength11 = validateLength(11, 'dígitos');

const EditAcountingDataModalForm = ({
  handleSubmit,
  onCancel,
  initialValues,
}) => {
  const [showVoucherCode, setShowVoucherCode] = useState(
    initialValues.newPaymentMethod.transactionCode &&
      initialValues.newPaymentMethod.transactionCode ===
        TRANSACTION_TYPE_CREDIT_CARD &&
      initialValues.voucherCode,
  );

  const handlePaymentMethodChange = (paymentMethod) => {
    setShowVoucherCode(
      paymentMethod.transactionCode &&
        paymentMethod.transactionCode === TRANSACTION_TYPE_CREDIT_CARD,
    );
  };

  const documentCodeField = initialValues.newBusinessName ? (
    <>
      <FormGroup row>
        <FormItem label="Razón Social" required>
          <Field
            name="newBusinessName"
            component={TextInput}
            type="text"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="RUC" required>
          <Field
            name="newBusinessTaxId"
            component={TextInput}
            type="text"
            validate={[
              isRequired,
              validateNumber,
              validateLength11,
              validateRuc,
            ]}
          />
        </FormItem>
      </FormGroup>
    </>
  ) : (
    <FormGroup row>
      <FormItem label="Nro de Dcocumento">
        <Field
          name="idDocumentNumber"
          component={TextInput}
          type="text"
          placeholder="Nùmero de Documento"
          validate={[isRequired, validateNumber]}
        />
      </FormItem>
    </FormGroup>
  );

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Método de Pago" required>
          <Field
            name="newPaymentMethod"
            component={PaymentMethodSelect}
            transactionCodesNotIncluded={[]}
            onChange={handlePaymentMethodChange}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      {showVoucherCode && (
        <FormGroup row>
          <FormItem label="Nro Referencia (POS)">
            <Field
              name="voucherCode"
              component={TextInput}
              type="text"
              placeholder="Nuevo Código de Voucher (Opcional)"
            />
          </FormItem>
        </FormGroup>
      )}
      {documentCodeField}
      <FormGroup row>
        <FormItem label="Comentario">
          <Field
            name="comment"
            component={TextInput}
            type="textarea"
            placeholder="Descripción"
          />
        </FormItem>
      </FormGroup>
      <FormFooter>
        <Button color="primary" onClick={onCancel}>
          Cancelar
        </Button>
      </FormFooter>
    </Form>
  );
};

EditAcountingDataModalForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({
    newPaymentMethod: PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
      transactionCode: PropTypes.string,
    }),
    voucherCode: PropTypes.string,
    newBusinessName: PropTypes.string,
    newBusinessTaxId: PropTypes.string,
  }).isRequired,
};

export default reduxForm({
  form: 'EditAcountingDataModal',
})(EditAcountingDataModalForm);
